module.exports = __webpack_public_path__ + "mo/img/swiper_bg04.06667a58.png";